module.exports = __webpack_public_path__ + "static/media/letter_h.cb5d427b.svg";